import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { fetchProductSchemaAndConfig } from '../configurations/fetchProductSchemaAndConfig'
import { getHeaders, getUrlWithVersion } from '../../../api/api'

export const uploadProductConfig = createAsyncThunk<
    void,
    { guid: string; formData: FormData; filename: string },
    ThunkConfig<string>
>('productsSlice/uploadProductConfig', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { guid, formData, filename } = args

    try {
        const response = await api.post(
            getUrlWithVersion(`/products/${guid}/configuration_file`),
            formData,
            {
                headers: getHeaders({
                    'Content-Type': 'multipart/formdata',
                    'Content-Disposition': `attachment; filename=${filename}`,
                }),
            }
        )

        if (response.status === 200) {
            throwSuccessMessage('Config uploaded')
            dispatch(fetchProductSchemaAndConfig({ guid, forceUpdate: true }))
        }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to upload product config')
    }
})
